export default "__VITE_ASSET__30d64b2c__"